import { RingIdentifier } from '@ringo/types'
import { PairShoppingCartItemDTOTypeEnum, ShoppingCartItemDTO } from '../generated'

export function calculateQuantity(item: ShoppingCartItemDTO, ringIdentifier: RingIdentifier) {
    if (item.type === PairShoppingCartItemDTOTypeEnum.PairItem) {
        return ringIdentifier === 'ring1' ? item.quantity1 : item.quantity2
    }

    return item.quantity
}

export function getFavoriteName(item: ShoppingCartItemDTO, ringIdentifier: RingIdentifier) {
    if (item.type === PairShoppingCartItemDTOTypeEnum.PairItem) {
        return ringIdentifier === 'ring1' ? item.favoriteName1 : item.favoriteName2
    }

    return item.favoriteName
}

export function calculateShoppingCartItemTotalPrice(item: ShoppingCartItemDTO, ringIdentifier: RingIdentifier): number {
    if (item.type === PairShoppingCartItemDTOTypeEnum.PairItem) {
        return ringIdentifier === 'ring1' ? item.ringPrice1.totalRingPrice * item.quantity1! : item.ringPrice2.totalRingPrice * item.quantity2!
    }

    return item.totalPrice || 0
}

export function calculateShoppingCartItemTotalWeight(item: ShoppingCartItemDTO, ringIdentifier: RingIdentifier): number {
    if (item.type === PairShoppingCartItemDTOTypeEnum.PairItem) {
        return ringIdentifier === 'ring1' ? (item.ringWeight1?.weight || 0) * item.quantity1! : (item.ringWeight2?.weight || 0) * item.quantity2!
    }

    return (item.ringWeight?.weight || 0) * item.quantity!
}
